import type { AdminRbacQueryInput } from '../interfaces';
import { createStore } from 'owa-satcheljs';

export interface PlacesManagementPermissionStore {
    permissionMap: Map<AdminRbacQueryInput, boolean>;
    pendingRequests: Map<AdminRbacQueryInput, Promise<void>>;
    latestedRequestId: Map<AdminRbacQueryInput, number>;
    counter: number;
}

export const getStore: () => PlacesManagementPermissionStore =
    createStore<PlacesManagementPermissionStore>('places-management-permission', {
        permissionMap: new Map<AdminRbacQueryInput, boolean>(),
        pendingRequests: new Map<AdminRbacQueryInput, Promise<void>>(),
        latestedRequestId: new Map<AdminRbacQueryInput, number>(),
        counter: 0,
    });
